import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ccb868b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap vote select_none" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = {
  key: 0,
  class: "mod_wrap_tbody"
}
const _hoisted_4 = { class: "vote_sel" }
const _hoisted_5 = { class: "vote_list" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "vote_img" }
const _hoisted_9 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_10 = { style: {"color":"#1890ff","cursor":"pointer"} }
const _hoisted_11 = { class: "vm_header" }
const _hoisted_12 = { class: "vmodel_head" }
const _hoisted_13 = { class: "vmodel_line" }
const _hoisted_14 = { class: "vmodel_head" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "vmodel_line" }
const _hoisted_18 = { class: "vmodel_head" }
const _hoisted_19 = { class: "vm_tbody" }
const _hoisted_20 = { class: "vmodel_con_name" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "vmodel_con_tic" }
const _hoisted_24 = { class: "vmodel_head" }
const _hoisted_25 = { class: "vmodel_line ticket" }
const _hoisted_26 = { class: "vmodel_line ticket" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "vmodel_line operation" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "百分比值总和不能大于100", -1))
const _hoisted_31 = { class: "confirm_btn" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "logo-modal" }
const _hoisted_34 = { class: "logo-modal-line" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "图标", -1))
const _hoisted_36 = { class: "logo-modal-line" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "中文文案", -1))
const _hoisted_38 = { class: "logo-modal-line" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "英文文案", -1))

import Crumb from '@/components/Crumb.vue';
import Create from './Create.vue';
import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { Table, Pagination, Modal, message, Progress, InputNumber, Tooltip, notification, Button, Popover} from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import { RollbackOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
import { computed, unref, ref, reactive, getCurrentInstance, onUnmounted, inject, watch } from 'vue';
import http from '@/api';
import { getToken } from '@/plugins/cookie';
import EventBus from '@/components/EventBus';
import { useHomeStore } from '@/pinia/home';
import { LiveInfo } from '@/store/modules/live/types';
import { useLiveStore } from '@/pinia/live';
import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';
import CUpload from '@/components/CUpload.vue';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
interface IVote {
  [x: string]: /* __placeholder__ */ any;
  select: number;
  title: string;
  proportion: number;
  img_url: string;
}
interface IOption {
  [x: string]: any;
  title: string;
  select: number;
  options: IVote[];
}

const __default__ = { name: 'Vote' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const aTable = Table;
const aModal = Modal;
const aPagination = Pagination;
const aProgress = Progress;
const aTooltip = Tooltip;
const aInputNumber = InputNumber;
const aButton = Button;
const aPopover = Popover;
const create_vote = ref(false); //创建页面显示
const vote_router_id = ref();
const createVoteView = () => {
  create_vote.value = true;
  vote_router_id.value = '';
};

// S-上传照片
const modelRef = ref({
  nameCN: '',
  nameEN: '',
});
const fileList = ref([]);
const loading = ref<boolean>(false);
const imageUrl = ref<string>('');
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    imageUrl.value = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  imageUrl.value = '';
};
// 图标设置
const logoModal = ref(false);
const openLogoModal = () => {
  logoModal.value = !logoModal.value;
};

const submit = () => {
  const data: any = {
    studio_id: liveStore.liveInfo.id,
    vote_icon: imageUrl.value,
    vote_text_ch: modelRef.value.nameCN,
    vote_text_en: modelRef.value.nameEN,
  };
  http.live
    .vote_icon(data)
    .then((res: any) => {
      message.success(res.data.message);
      openLogoModal();
      getVote();
    })
    .catch((err: any) => message.error(err.data.error));
};
const getVote = useDebounce(() => {
  const data: any = {
    studio_id: liveBroadcastingRoomId,
  };
  http.live
    .get_vote_icon({ params: data })
    .then((res: any) => {
      imageUrl.value = res.data.data.vote_icon;
      modelRef.value.nameCN = res.data.data.vote_text_ch;
      modelRef.value.nameEN = res.data.data.vote_text_en;
    })
    .catch((err: any) => message.error(err.data.error));
});
getVote();
const confirmVirtaulVote = (i: any) => {
  // const num = i.virtualVote || 0;
  // if (!num) {
  //   message.success('ok');
  //   return;
  // }
  
  const percentage_data = i.options.map((item: any) => {
    return {
      id: item.id,
      percentage: item.virtualVote || 0,
      number_false: item.select_false,
      number:item.select,
    };
  });
  http.live
    .updateVirtualVote({
      id: i.id,
      percentage_data: JSON.stringify(percentage_data),
    })
    .then((res) => {
    if(res.data.code==200){
      message.success(res.data.message);
      updateVirtualVoteCache();
      voteResult(vote_id.value);
    }else{
      message.error(res.data.error);
    }
     
    }).catch((error)=>{
      message.error(error.data.error);
    })
};
const editVoteView = (e: any) => {
  create_vote.value = true;
  vote_router_id.value = e.id;
};
const getCreateStatus = (data: any) => {
  create_vote.value = data;
  getVoteList();
};
const liveBroadcastingRoomId = route.params.studioId;
const voteSwitch = (id: number) => {
  const data = {
    id: id,
  };
  http.live.voteSwitch(data).then((res) => {
    message.success(res.data.message);
  });
};
const showLoading = ref<boolean>(false);
const voteList = ref([]);
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 10, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
const getVoteList = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    page: pageConfigure.current,
    page_num: pageConfigure.pageSize,
  };
  showLoading.value = true;
  http.live
    .getVoteList({ params: data })
    .then((res) => {
      pageConfigure.totalSize = res.data.data.total;
      const resData = res.data.data.data;
      voteList.value = resData.map((res: any) => {
        res.status = Boolean(res.status);
        return res;
      });
      showLoading.value = false;
    })
    .catch((err) => {
      showLoading.value = false;
    });
});
getVoteList();
const showSize = () => {
  getVoteList();
};
// interface ObjResult {
//   id?: number;
//   theme?: string;
//   result?: number;
//   type?: number;
//   end_at?: '';
//   number: number;
// }
const vote_result = ref({
  id: '',
  theme: '',
  result: 1,
  type: 1,
  end_at: '',
  number: 1,
  style: 0,
  head_image: '',
});
const resultOptions = reactive<IOption[]>([]);

let virtualVotesCache = new Map();
let virtualVotesCacheDirty = false;
const updateVirtualVoteCache = () => {
  resultOptions.forEach((item) => {
    let map = virtualVotesCache.get(item.id);
    if (!map) {
      map = virtualVotesCache.set(item.id, new Map());
    }
    item.options.forEach((vote) => {
      map.set(vote.id, vote.virtualVote);
    });
  });
};
function setResultOptions(options: IOption[]) {
  if (virtualVotesCacheDirty) {
    virtualVotesCache.clear();
    virtualVotesCacheDirty = false;
  }
  options.forEach((item) => {
    const map1 = virtualVotesCache.get(item.id);
    item.options.forEach((vote) => {
      vote.virtualVote = map1 ? map1.get(vote.id) : '';
    });
  });
  resultOptions.length = 0;
  resultOptions.push(...options);
  updateVirtualVoteCache();
}
const vote_id = ref();
watch(vote_id, () => {
  virtualVotesCacheDirty = true;
});
const voteResult = (id: number) => {
  vote_id.value = id;
  blatant.value = true;
  const data = {
    id: id,
  };
  http.live.voteResult({ params: data }).then((res) => {
    vote_result.value = res.data.data;
    setResultOptions(JSON.parse(res.data.data.items));
  });
};

const token = getToken();
const homeStore = useHomeStore();
const liveStore = useLiveStore();

const initJoin = (data?: any) => {
  if (!data && !homeStore.clientId) {
    return;
  }
  homeStore.clientId = data ? data.client_id : homeStore.clientId;
  http.liveChat.joinChat({
    type: 'join',
    studio_id: liveStore.liveInfo.id,
    client_id: homeStore.clientId,
  });
};

initJoin();
const updateVote = (data: any) => {
  voteList.value.forEach((e: any) => {
    if (e.id === data.vote_id) {
      e.number = data.vote_number;
    }
  });
  if (vote_id.value === data.vote_id) {
    vote_result.value.number = data.vote_number;
    setResultOptions(JSON.parse(data.vote_result));
  }
};

EventBus.on('init', initJoin);
EventBus.on('updateVote', updateVote);
onUnmounted(() => {
  EventBus.off('init', initJoin);
  EventBus.off('updateVote', updateVote);
});

const selectedRowKeys = ref<Key[]>([]);
//如果没有选中，不能删除
const getSelected = computed(() => selectedRowKeys.value.length === 0);
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const checkAll = ref(false);
const onSelectAllChange = () => {
  if (checkAll.value) {
    selectedRowKeys.value = voteList.value.map((e: any) => e.id);
  } else {
    selectedRowKeys.value = [];
  }
};
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};

const voteDel = () => {
  delModal.visible = false;

  const data = {
    ids: selectedRowKeys.value.toString(),
    studio_id: liveBroadcastingRoomId,
  };
  http.live.voteDel(data).then((res) => {
    if (res.data.code === 200) {
      message.success(res.data.message);
      getVoteList();
      selectedRowKeys.value.length = 0;
    }
  });
};

const columns = [
  {
    title: '投票主题',
    dataIndex: 'theme',
    width: '200px',
    align: 'center',
  },
  {
    title: '截至时间',
    dataIndex: 'end_at',
    width: '18%',
    align: 'center',
    slots: { customRender: 'end_at' },
  },
  {
    title: '人数',
    dataIndex: 'number',
    width: '18%',
    align: 'center',
  },
  {
    title: '功能开关',
    dataIndex: 'status',
    width: '18%',
    align: 'center',
    slots: { customRender: 'address' },
  },
  {
    title: '操作',
    dataIndex: 'img',
    width: '18%',
    align: 'center',
    slots: { customRender: 'img' },
  },
];
const blatant = ref<boolean>(false);
const votePopupSwitch = (record: { id: any }) => {
  const data = {
    id: record.id,
  };
  http.live
    .votePopup(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

const handleOk = (e: MouseEvent) => {
  // console.log(e);
  blatant.value = false;
};

watch(blatant, (value) => {
  if (!value) {
    resultOptions.forEach((item) => {
      item.options.forEach((vote) => {
        vote.virtualVote = '';
      });
    });
    updateVirtualVoteCache();
  }
});

// 导出
const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const messageTip = ref();
const openEx = useDebounce((type: number) => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: type,
    is_cron_download: corn.value,
    vote_id: vote_result.value.id,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error;
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
    duration: 5,
  });
};
//test-login.lighos.com/api/v1/common/excel_regional_distribution?token=&studio_id=10001458&type=13&vote_id=495

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 互动投票 "),
        (create_vote.value === true)
          ? (_openBlock(), _createBlock(_unref(aButton), {
              key: 0,
              class: "create_link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (create_vote.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RollbackOutlined)),
                _createTextVNode("   返回列表 ")
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(aButton), {
              key: 1,
              class: "mod_btn order",
              onClick: openLogoModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("图标设置")
              ]),
              _: 1
            }))
      ]),
      (!create_vote.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(aButton), {
              type: "primary",
              onClick: createVoteView
            }, {
              default: _withCtx(() => [
                _createTextVNode("新建投票 ")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_checkbox, {
                class: "checkbox",
                checked: checkAll.value,
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((checkAll).value = $event)),
                disabled: voteList.value.length === 0,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (onSelectAllChange()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全选")
                ]),
                _: 1
              }, 8, ["checked", "disabled"]),
              _createVNode(_unref(aButton), {
                class: "mod_btn",
                type: "link",
                danger: "",
                disabled: _unref(getSelected),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (openDelModal()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_btn_icon",
                    "icon-class": "del"
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                "row-selection": _unref(rowSelection),
                columns: columns,
                "data-source": voteList.value,
                rowKey: "id",
                pagination: false,
                ellipsis: true,
                class: "vl_table"
              }, {
                end_at: _withCtx(({ record }) => [
                  (record.end_at === '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "不限"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.end_at), 1))
                ]),
                address: _withCtx(({ record }) => [
                  _createVNode(_component_a_switch, {
                    checked: record.status,
                    "onUpdate:checked": ($event: any) => ((record.status) = $event),
                    onChange: ($event: any) => (voteSwitch(record.id))
                  }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                ]),
                img: _withCtx(({ record }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(aTooltip), {
                      placement: "top",
                      title: "查看"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aButton), {
                          type: "link",
                          onClick: ($event: any) => (voteResult(record.id)),
                          class: "vote_button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, { "icon-class": "vote_img" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(aTooltip), {
                      placement: "top",
                      title: "弹出"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aButton), {
                          type: "link",
                          onClick: ($event: any) => (votePopupSwitch(record)),
                          class: "vote_button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, { "icon-class": "vote_img_list" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(aTooltip), {
                      placement: "top",
                      title: "修改"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(aButton), {
                          type: "link",
                          class: "vote_button",
                          onClick: ($event: any) => (editVoteView(record))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, { "icon-class": "vote_imge" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "row-selection", "data-source"])
            ]),
            _createVNode(_unref(aPagination), {
              "show-quick-jumper": "",
              current: pageConfigure.current,
              "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfigure.current) = $event)),
              pageSize: pageConfigure.pageSize,
              "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfigure.pageSize) = $event)),
              onShowSizeChange: showSize,
              onChange: showSize,
              pageSizeOptions: pageConfigure.options,
              total: pageConfigure.totalSize,
              "show-less-items": "",
              "show-size-changer": "",
              class: "vote_page"
            }, null, 8, ["current", "pageSize", "pageSizeOptions", "total"])
          ]))
        : (_openBlock(), _createBlock(Create, {
            key: 1,
            "data-source": {
        studioId: _unref(liveBroadcastingRoomId),
        voteId: vote_router_id.value,
      },
            onCreateStatus: getCreateStatus
          }, null, 8, ["data-source"])),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: openDelModal,
        ok: voteDel
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将删除该文件，是否继续？")
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: blatant.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((blatant).value = $event)),
        width: "806px",
        height: "692px",
        cancelText: " ",
        okText: " ",
        title: "投票结果",
        onOk: handleOk,
        centered: "",
        class: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(openEx)(13)))
              }, "导出记录"),
              _createTextVNode(" | "),
              _createElementVNode("span", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(openEx)(25)))
              }, "导出结果")
            ]),
            _createVNode(_unref(aButton), {
              class: "mod_modal_btn mod_type_primary",
              onClick: handleOk
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, "投票主题：" + _toDisplayString(vote_result.value.theme), 1),
              _createElementVNode("div", _hoisted_13, "投票结果：" + _toDisplayString(vote_result.value.result === 0 ? '未对观众开放' : '对观众开放'), 1),
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(" 截止时间："),
                (vote_result.value.end_at != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(vote_result.value.end_at), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, "不限"))
              ]),
              _createElementVNode("div", _hoisted_17, "投票人数：" + _toDisplayString(vote_result.value.number), 1),
              _createElementVNode("div", _hoisted_18, "投票方式：" + _toDisplayString(vote_result.value.type === 0 ? '文字投票' : '图文投票'), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultOptions, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "vmodel_con",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(item.title) + " ", 1),
                    (item.select != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(多选)"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, "(单选)"))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (i, n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i.id
                    }, [
                      _createVNode(_unref(aProgress), {
                        percent: i.proportion,
                        "show-info": false,
                        "stroke-color": { from: '#00e1af', to: '#00e1af' },
                        class: "vmodel_con_date"
                      }, null, 8, ["percent"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, "选项" + _toDisplayString(n + 1) + "：" + _toDisplayString(i.title), 1),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(i.proportion) + "%", 1),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(i.select) + "票", 1),
                        (i.img_url && vote_result.value.type != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("img", {
                                src: i.img_url,
                                class: "vm_img"
                              }, null, 8, _hoisted_28)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_29, [
                          _createTextVNode(" 最终百分比"),
                          _createVNode(_unref(aInputNumber), {
                            style: {"width":"70px"},
                            size: "small",
                            value: i.virtualVote,
                            "onUpdate:value": ($event: any) => ((i.virtualVote) = $event),
                            onChange: updateVirtualVoteCache,
                            min: 1
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_unref(aPopover), {
                            placement: "right",
                            class: "switch_tips"
                          }, {
                            content: _withCtx(() => [
                              _hoisted_30
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(QuestionCircleFilled))
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", {
                      class: "link",
                      onClick: ($event: any) => (confirmVirtaulVote(item))
                    }, "确认", 8, _hoisted_32)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(aModal), {
        visible: logoModal.value,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((logoModal).value = $event)),
        title: "图标设置",
        centered: "",
        onOk: submit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(CUpload, {
                    "file-list": fileList.value,
                    "handle-change": handleChange,
                    loading: loading.value,
                    "image-name": imageUrl.value,
                    "click-stop": imageDel,
                    class: "ant_upload"
                  }, null, 8, ["file-list", "loading", "image-name"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_a_form_item, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: modelRef.value.nameCN,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((modelRef.value.nameCN) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(_component_a_form_item, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: modelRef.value.nameEN,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((modelRef.value.nameEN) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})